import type { QueryClient } from '@tanstack/react-query';
import type { CorSelo } from '../../componentes/base';

export type Estado = 'rascunho' | 'enviada' | 'aprovada' | 'recusada' | 'reembolsada';
export const ESTADOS: Estado[] = ['rascunho', 'enviada', 'aprovada', 'recusada', 'reembolsada'];
export const COR_ESTADO: Record<Estado, CorSelo> = { rascunho: 'neutro', enviada: 'laranja', aprovada: 'azul', recusada: 'perigo', reembolsada: 'verde' };

export interface Despesa {
  id: string;
  funcionario_id: string;
  funcionario_nome: string | null;
  data: string;
  descricao: string;
  categoria_id: string;
  categoria_nome: string | null;
  centro_custo_id: string | null;
  centro_custo_nome: string | null;
  valor_centavos: number;
  comprovante_anexo_id: string | null;
  comprovante_nome: string | null;
  estado: Estado;
  enviada_em: string | null;
  motivo_decisao: string | null;
  decidido_por_nome: string | null;
  decidido_em: string | null;
  reembolso_id: string | null;
  empresa_id: string | null;
  created_at: string;
  pode_editar?: boolean;
  pode_decidir?: boolean;
}

export interface Reembolso {
  id: string;
  funcionario_id: string;
  funcionario_nome: string | null;
  vencimento: string;
  valor_centavos: number;
  despesas: number;
  documento_id: string | null;
  documento_numero: string | null;
  documento_estado: string | null;
  destino: 'contas' | 'folha';
  folha_ano_mes: string | null;
  created_at: string;
}

export interface Classificacao {
  categorias: { id: string; nome: string; codigo: string | null }[];
  centros: { id: string; nome: string }[];
}

export const invalidarDespesas = (qc: QueryClient) => qc.invalidateQueries({ queryKey: ['despesas'] });
